import { gql, useQuery } from '@apollo/client';

const defaultFields = `
    id
    recordId
    firstName
    lastName
    suffix
    title
    photoUrl
    status
    company {
        recordId
        name
    }
    address {
        purpose
        city
        stateProvince
        country
    }
    events {
        recordId
        code
    }
`;

const useSavedContacts = ({ fields, options } = { fields: defaultFields, options: {} }) => {
    return useQuery(
        gql`query getSavedContacts {
            contacts {
                ${fields || defaultFields}
            }
        }`,
        options || {}
    );
};

export default useSavedContacts;
